import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { Step } from '../interfaces/step.interface';
import { BookingErrorSteps, BookingSteps } from '../interfaces/booking/booking-step.interface';

export const ERROR_STEPS: BookingErrorSteps = {
  ERROR_ROUTE: {
    phase: 0,
    id: 0,
    path: 'error/:error',
    translationKey: null,
  },
  ERROR: {
    phase: 0,
    id: 0,
    path: 'error',
    translationKey: null,
  },
  PAYMENT_ERROR: {
    phase: 0,
    id: 0,
    path: 'payment/error',
    translationKey: null,
  },
};

let phaseGenerator = 0;
let idGenerator = 0;
export const BOOKING_STEPS: BookingSteps = {
  ENTRY: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: '',
    translationKey: 'tripDetails',
    metaKey: 'tripDetails',
  },
  FLIGHT_SELECTION: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'flight-selection',
    translationKey: 'flightSelection',
    metaKey: 'flights',
    icon: SvgLibraryIcon.AIRCRAFT_TILTED,
  },
  PAXDETAILS: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'passenger-details',
    translationKey: 'passengerDetails',
    metaKey: 'passengers',
    icon: SvgLibraryIcon.MULTI_PAX,
  },
  SEATS: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'seat-map',
    translationKey: 'seatMap',
    metaKey: 'seatMap',
    icon: SvgLibraryIcon.SEAT_OR_ECONOMY,
  },
  BAGS: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'baggage',
    translationKey: 'baggage',
    metaKey: 'baggage',
    icon: SvgLibraryIcon.EXTRA_CHECK_IN_BAGGAGE,
  },
  ANCILLARIES: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'ancillaries',
    translationKey: 'travelExtras',
    metaKey: 'extras',
    icon: SvgLibraryIcon.FOOD,
  },
  PURCHASE_REVIEW: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'purchase-review',
    translationKey: 'reviewAndPay',
    metaKey: 'review',
    icon: SvgLibraryIcon.SECURE_PAYMENT,
  },
  CHECKOUT: {
    phase: phaseGenerator,
    id: ++idGenerator,
    path: 'checkout',
    translationKey: 'reviewAndPay',
    metaKey: 'payment',
  },
  PURCHASE_SUCCESS: {
    phase: ++phaseGenerator,
    id: ++idGenerator,
    path: 'confirmation',
    translationKey: 'success',
    metaKey: 'success',
  },
};

export const BOOKING_STEPS_ARRAY: Step[] = Object.keys(BOOKING_STEPS)
  .filter((key) => !BOOKING_STEPS[key].disabled)
  .map((key) => BOOKING_STEPS[key]);

export const FLIGHT_SELECTION_CACHE_EXPIRY = 1000 * 60 * 15; // 15 minutes

export const fareFamiliesWithoutCampaignFiltering = {
  ABCLASIC04: 'ABCCAMP01', // (BIZ, ES TO NA)
  ABCLASIC01: 'ABCCAMP01', // (BIZ, GB TO NA)
  AECLASIC01: 'AECCAMP01', // (ECO, ES/GB TO NA)
  APECLASI01: 'APECCAMP01', // (PE, ES/GB TO NA)
};
